import { render, staticRenderFns } from "./ModalRejectPayment.vue?vue&type=template&id=20c52bf6&scoped=true&"
import script from "./ModalRejectPayment.vue?vue&type=script&lang=js&"
export * from "./ModalRejectPayment.vue?vue&type=script&lang=js&"
import style0 from "./ModalRejectPayment.vue?vue&type=style&index=0&id=20c52bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c52bf6",
  null
  
)

export default component.exports